import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { emailSigninSchema, type EmailSigninData } from '@/lib/validations/auth';
import { useEmailSignin } from '@/hooks/useEmailAuth';
import { PasswordInput } from './PasswordInput';

export const EmailSigninForm = () => {
  const { signin, isLoading } = useEmailSignin();
  
  const form = useForm<EmailSigninData>({
    resolver: zodResolver(emailSigninSchema),
    defaultValues: {
      email: '',
      password: ''
    }
  });

  const onSubmit = (data: EmailSigninData) => {
    signin(data);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="Enter your email" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <div className="flex items-center justify-between">
                <FormLabel>Password</FormLabel>
                <Link
                  to="/forgot-password"
                  className="text-xs text-[#290BD9] hover:text-[#2309C5] underline"
                >
                  Forgot password?
                </Link>
              </div>
              <FormControl>
                <PasswordInput placeholder="Enter your password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button
          type="submit"
          className="w-full"
          disabled={isLoading}
        >
          {isLoading ? 'Signing In...' : 'Sign In'}
        </Button>
      </form>
    </Form>
  );
};